/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import { useQuery } from '@tanstack/react-query';
import { walletService } from '../services/api';
import { WalletSummary } from '../types';
import { useAuthStore } from '../store/authStore';

export const useWallet = () => {
  const { isAuthenticated, isLoading: authLoading } = useAuthStore();

  const { data: walletData, isLoading, isPending, isError, refetch } = useQuery({
    queryKey: ['wallet'],
    queryFn: () => walletService.get().then((res) => res.data),
    staleTime: 30000, // Cache for 30 seconds
    enabled: isAuthenticated && !authLoading,
  });

  const wallet = walletData as WalletSummary | undefined;

  return {
    wallet,
    balance: wallet?.balance ?? 0,
    availableBalance: wallet?.available_balance ?? 0,
    minimumRequired: wallet?.minimum_required ?? 0,
    canCreateResources: wallet?.can_create_resources ?? false,
    accountType: wallet?.account_type ?? 'prepaid',
    // Run rate information
    hourlyRunRate: wallet?.hourly_run_rate ?? 0,
    estimatedHoursLeft: wallet?.estimated_hours_left ?? 0,
    hasRunningResources: wallet?.has_running_resources ?? false,
    // Low balance status
    isLowBalance: wallet?.is_low_balance ?? false,
    lowBalanceNotificationCount: wallet?.low_balance_notification_count ?? 0,
    servicesStoppedForBalance: wallet?.services_stopped_for_balance ?? false,
    isLoading: isLoading || isPending,
    isError,
    refetch,
  };
};
